import { storageService } from "./storageService";
import { axiosService } from ".";
import { getDeviceInfo } from "../utilities/deviceInfo";

export class AuthService {
  authSuccess = ({accessToken, refreshToken }: any = {}) => {
    storageService.set('accessToken', accessToken);
  }

  signOut = () => {
    storageService.remove('accessToken');
    storageService.remove('refreshToken');
    storageService.remove('name');
    storageService.remove('lastRequested');
  };

  requestOtp = async ({ mobile, via, otpToken }: { mobile: string; via?: 'whatsapp' | 'sms'; otpToken?: string }) => {
    try {
      const { data: response }: any = await axiosService.withoutToken().post('user/auth/requestOtp', { mobile, via, otpToken });
      return response
    } catch (error) {
      console.error("Error in authenticating!");
    }
  }

  verifyOtp = async ({ mobile, otp, otpToken }: any) => {
    try {
      const { data: response }: any = await axiosService.withoutToken().post('user/auth/verifyOtp', {
        mobile,
        otp,
        otpToken,
        // Tags productMetadata.SUPER_PREP and seeds the per-product lastDevice +
        // installedPlatforms (platform 'WEB') for web sessions.
        appContext: 'SUPER_PREP',
        deviceInfo: getDeviceInfo() || undefined,
      });
      return response
    } catch (error) {
      console.error("Error in authenticating!");
      return { error }
    }
  }

  verifyJwt = async () => {
    try {
      const { data: response }: any = await axiosService.setAuth(true).post('user/auth/verify');
      return response
    } catch (error: any) {
      console.error("JWT verification failed!", error);
      const status = error && error.response && error.response.status;
      // Only treat as invalid JWT if server explicitly returned 401
      // Network errors / timeouts / 5xx mean service is down — keep token
      if (status === 401) {
        return null;
      }
      return { serviceUnavailable: true };
    }
  }

  get isLoggedIn() {
    const token = storageService.get('accessToken');
    return !!token;
  }

  get userName() {
    const name = storageService.get('name');
    return name;
  }
}
const authServiceInstance = new AuthService();

export { authServiceInstance as authService };
